<template>
    <HamletTable
        :fetch="fetch"
        :columns="columns"
        :default-per-page="savedPerPage"
        :default-page="savedPage"
        @onRowClick="edit"
        @per-page-change="onPerPageChange"
        @page-change="onPageChange"
    >
        <template #header-label>
            Questions
        </template>

        <template #header-controls>
            <Button
                v-if="$can('visit', 'administration-legislation-question-group-create')"
                class="mt-0 btn-icon"
                @click="create"
            >
                <feather-icon icon="PlusIcon" />
            </Button>
        </template>

        <template #cell-scope="data">
            {{ scopeTitle(data.item.scope) }}
        </template>

        <template #cell-validFrom="data">
            {{ renderDate(data.item.validFrom) }}
        </template>

        <template #cell-validTo="data">
            <OngoingDateBadge :date="data.item.validTo" />
        </template>
    </HamletTable>
</template>

<script>
import OngoingDateBadge from '@core/components/common/OngoingDateBadge.vue'
import { Button, HamletTable } from '@core/components/common'
import { LegislationApi } from '@core/api'
import dateRenderer from '@core/mixins/date-renderer'

const DEFAULT_PER_PAGE = 15
const SETTINGS_KEY = 'legislationQuestionGroupsSettings'

function normalizeSettings(settings) {
    if (!settings || typeof settings !== 'object' || Array.isArray(settings)) {
        return {
            perPage: DEFAULT_PER_PAGE,
            page: 1,
        }
    }

    return {
        perPage: Number(settings.perPage) || DEFAULT_PER_PAGE,
        page: Number(settings.page) || 1,
    }
}

export default {
    components: {
        HamletTable,
        OngoingDateBadge,
        Button,
    },
    mixins: [dateRenderer],
    data() {
        const savedSettings = normalizeSettings(this.$store.getters.runtimeConfig[SETTINGS_KEY])

        return {
            savedPerPage: savedSettings.perPage,
            savedPage: savedSettings.page,
            scopeOptions: [
                { id: 'within_eu', title: 'within_eu' },
                { id: 'outside_eu', title: 'outside_eu' },
                { id: null, title: 'null' },
            ],
            columns: [
                {
                    key: 'title',
                    label: this.$t('Component(Grid):column-title'),
                },
                {
                    key: 'scope',
                    label: this.$t('Component(Grid):column-scope'),
                },
                {
                    key: 'questionsCount',
                    label: this.$t('Component(Grid):column-questions-count'),
                },
                {
                    key: 'validFrom',
                    label: this.$t('Component(Grid):column-valid-from'),
                },
                {
                    key: 'validTo',
                    label: this.$t('Component(Grid):column-valid-to'),
                },
            ],
        }
    },
    methods: {
        fetch(config, cb) {
            this.savedPage = config.page
            this.savedPerPage = config.perPage
            this.saveSettings()

            return LegislationApi
                .getQuestionGroups([], {}, config.page, config.perPage)
                .then(r => cb(r.data.totalItems, r.data.items))
        },
        create() {
            this.$router.push({
                name: 'administration-legislation-question-group-create',
            })
        },
        edit(questionGroup) {
            if (this.$can('visit', 'administration-legislation-question-group-card')) {
                this.$router.push({
                    name: 'administration-legislation-question-group-card',
                    params: { id: questionGroup.id },
                })
            }
        },
        scopeTitle(scope) {
            const option = this.scopeOptions.find(scopeOption => scopeOption.id === scope)

            return option ? option.title : scope
        },
        onPerPageChange(perPage) {
            this.savedPerPage = perPage
            this.saveSettings()
        },
        onPageChange(page) {
            this.savedPage = page
            this.saveSettings()
        },
        saveSettings() {
            this.$store.dispatch('setRuntimeProperty', {
                name: SETTINGS_KEY,
                value: {
                    perPage: this.savedPerPage,
                    page: this.savedPage,
                },
                removeOnOrganizationSwitch: true,
            })
        },
    },
}
</script>
